export default __webpack_public_path__ + "static/media/step2.55b45233.png";